import CTAButton from "./CTAButton";

export default function FinalCTA({
  content = {},
  productImage,
  price,
  comparePrice,
  hasComparePrice,
  formatRupiah,
  onCheckout,
  canCheckout,
  onWhatsapp,
  whatsappEnabled,
}) {
  const title = content.title || "Mulai Kebiasaan Sehat Anda Hari Ini";
  const desc = content.desc || "";
  const badge = content.badge || "🌺 Penawaran Terakhir";
  const couponCode = content.coupon_code || "";
  const couponLabel = content.coupon_label || "Kode Diskon";
  const ctaCheckout = content.cta_checkout || "Checkout Sekarang";
  const ctaWhatsapp = content.cta_whatsapp || "Konsultasi WhatsApp";

  return (
    <section className="relative overflow-hidden py-24 lg:py-32 text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${productImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-[oklch(0.38_0.18_25/0.9)] via-[oklch(0.52_0.22_25/0.85)] to-[oklch(0.38_0.18_25/0.95)]" />
      <div className="relative mx-auto max-w-3xl px-5 text-center">
        <span className="inline-block rounded-full bg-white/15 backdrop-blur-md border border-white/30 px-4 py-1.5 text-xs font-bold uppercase tracking-widest">
          {badge}
        </span>
        <h2 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-balance">
          {title}
        </h2>
        {desc && (
          <p className="mt-5 text-white/90 text-lg max-w-xl mx-auto">
            {desc}
          </p>
        )}

        <div className="mt-10 inline-block rounded-[2rem] bg-white text-foreground p-8 shadow-luxury">
          <div className="text-xs uppercase tracking-widest text-muted-foreground">Harga Promo Hari Ini</div>
          <div className="font-display text-6xl sm:text-7xl font-extrabold text-primary leading-none mt-1">
            {price ? formatRupiah(price) : "Harga Promo"}
          </div>
          {hasComparePrice && (
            <div className="text-sm text-muted-foreground mt-2 line-through">{formatRupiah(comparePrice)}</div>
          )}

          {couponCode && (
            <div className="mt-6 rounded-2xl border-2 border-dashed border-[oklch(0.52_0.22_25/0.4)] bg-[var(--kp-accent)]/50 px-5 py-3">
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{couponLabel}</div>
              <div className="font-display font-extrabold text-2xl text-primary">{couponCode}</div>
            </div>
          )}

          <div className="mt-6">
            <CTAButton size="xl" fullWidth pulse onClick={onCheckout} disabled={!canCheckout}>
              🛒 {ctaCheckout}
            </CTAButton>
          </div>
        </div>

        {whatsappEnabled && (
          <div className="mt-6">
            <button
              onClick={onWhatsapp}
              className="inline-flex items-center justify-center gap-2 h-14 px-7 rounded-full border border-white/40 text-base font-semibold text-white hover:bg-white/10 transition-all"
            >
              💬 {ctaWhatsapp}
            </button>
          </div>
        )}

        <p className="mt-8 text-xs text-white/70 uppercase tracking-widest">
          🔒 Pembayaran Aman • 🚚 Dikirim Seluruh Indonesia
        </p>
      </div>
    </section>
  );
}
